var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Tablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 49h20v4H7.81A3.87 3.87 0 014 49.18V19.81A3.87 3.87 0 017.82 16h45.37A3.87 3.87 0 0157 19.82V37h-4V20H8v29zm52-7H45.5a1.5 1.5 0 100 3H51v2H39.5a1.5 1.5 0 100 3H51v2H33.5a1.5 1.5 0 100 3H51v2H38.5a1.5 1.5 0 100 3H57v2h-7.5a1.5 1.5 0 100 3H61c6.41 0 11-5.46 11-11.5C72 47.15 66.85 42 60 42zM40 26H14v4h26v-4zM14 38h13v-4H14v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Tablet.94ef24fc.svg";
export { SvgH1Tablet as ReactComponent };